import React from 'react';
import { useAppSelector } from 'hooks';

import { deriveFormattedDateRange } from '~support-at-home/lib/derive';

import Icon, { faCalendar, faUser } from '~components/icon';

import { selectClientFormOptions } from '~lookups/selectors/clientFormOptions';

interface ComponentProps {
  value: { start_date: any; end_date: any; naps_id?: any };
  showNapsFilter?: boolean;
}

const ClaimRange: React.FC<ComponentProps> = ({ value, showNapsFilter = false }) => {
  const { start_date, end_date, naps_id } = value;
  const clientFormOptions = useAppSelector(selectClientFormOptions);

  const selectedOptions =
    naps_id && naps_id.length > 0 ? clientFormOptions.filter((option) => naps_id.includes(option.id)) : [];

  const napsText = selectedOptions.length > 0 ? selectedOptions.map((opt) => opt.name).join(', ') : 'All';

  return (
    <div>
      <div className="row g-3 mb-3">
        <div className={showNapsFilter ? 'col-md-6' : 'col-12'}>
          <div className="d-flex align-items-center bg-light rounded p-3 h-100">
            <Icon icon={faCalendar} className="text-secondary me-3" />

            <div className="d-flex flex-column">
              <h6 className="fw-semibold text-muted mb-1">Claiming Period</h6>
              <span className="fw-medium">{deriveFormattedDateRange({ start_date, end_date })}</span>
            </div>
          </div>
        </div>

        {showNapsFilter && (
          <div className="col-md-6">
            <div className="d-flex align-items-center bg-light rounded p-3 h-100">
              <Icon icon={faUser} className="text-secondary me-3" />

              <div className="d-flex flex-column">
                <h6 className="fw-semibold text-muted mb-1">NAPS Service IDs</h6>
                <span className="fw-medium">{napsText}</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ClaimRange;
